<template>
  <div class="ftv-con">
    <!-- <div class="item-title-container">
      <div class="item-title" @click="$parent.onClickTopic(webItem.id)">
        {{ webItem.title }}
      </div>
    </div> -->
    <div class="item-title-container" @click="onOpenFixtop(17)">
      <div class="item-red"></div>
      <div class="item-title">
        {{ content.title }}
      </div>
      <div class="item-icon">{{ content.subTitle }}</div>
    </div>
    <div class="ftv-model-3s" v-if="webItem.model == '3s'">
      <div
        v-for="(pic, contentIndex) in webItem.list"
        :key="contentIndex + 'FTV' + pic.id"
        class="pic"
        :style="{ backgroundImage: `url(` + pic.imgURL + `)` }"
        :class="{ active: content.picIndex == contentIndex }"
        @click="onLookPost(pic.postId)"
      ></div>
      <div class="text">
        <div
          v-for="(pic, navIndex) in webItem.list"
          :key="'ftv_' + pic.id + '_nav' + '_' + navIndex"
          class="nav-pic"
          :class="{ active: content.picIndex == navIndex }"
          @click="scrollTo(index, navIndex)"
        ></div>
      </div>
    </div>

    <div class="ftv-model-m_swiper" v-if="webItem.model == 'm_swiper'">
      <div class="swiper-list" v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight">
        <template v-for="(video, contentIndex) in webItem.list">
          <div :key="contentIndex + 'FTS' + video.id" class="video-item" @click="onLookPost(video.postId)">
            <video
              :src="video.videoURL"
              :poster="video.posterURL"
              :ref="'video_' + video.postId"
              @mouseenter="onVideoEnter('video_' + video.postId)"
              @mouseleave="onVideoLeave('video_' + video.postId)"
              loop
              :muted="video.mute"
            ></video>
            <i
              class="mute el-icon-headset active"
              v-if="video.mute"
              @mouseenter="onVideoEnter('video_' + video.postId)"
              @mouseleave="onVideoLeave('video_' + video.postId)"
              @click.stop="video.mute = !video.mute"
            ></i>
            <i
              class="mute el-icon-headset"
              v-if="!video.mute"
              @mouseenter="onVideoEnter('video_' + video.postId)"
              @mouseleave="onVideoLeave('video_' + video.postId)"
              @click.stop="video.mute = !video.mute"
            ></i>
            <div class="video-play"></div>
            <div class="video-text">
              <div class="title">{{ video.title }}</div>
              <div class="author">{{ video.author }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 固定栏目其它 -->
    <div :class="'ftv-model-' + webItem.model" v-else>
      <div class="post-con" v-for="video in webItem.list" :key="'ftv_' + video.postId" @click="onLookPost(video.postId)">
        <video
          :src="video.videoURL"
          :poster="video.posterURL"
          :ref="'video_' + video.postId"
          @mouseenter="onVideoEnter('video_' + video.postId)"
          @mouseleave="onVideoLeave('video_' + video.postId)"
          loop
          :muted="video.mute"
        ></video>
        <i
          class="mute el-icon-headset active"
          v-if="video.mute"
          @mouseenter="onVideoEnter('video_' + video.postId)"
          @mouseleave="onVideoLeave('video_' + video.postId)"
          @click.stop="video.mute = !video.mute"
        ></i>
        <i
          class="mute el-icon-headset"
          v-if="!video.mute"
          @mouseenter="onVideoEnter('video_' + video.postId)"
          @mouseleave="onVideoLeave('video_' + video.postId)"
          @click.stop="video.mute = !video.mute"
        ></i>
        <div class="video-text">
          {{ video.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RD from '@/api/RD'

export default {
  name: 'IndexFtv',
  components: {},
  props: {
    content: {
      type: Object,
      default: function () {
        return {}
      },
    },
    logined: {
      type: Boolean,
      default: function () {
        return false
      },
    },
  },
  data: function () {
    return {
      webItem: {}, // 视频处理后的数据data
      swipeIndex: 0, // 轮播的Index
    }
  },
  created() {
    this.reload()
  },
  methods: {
    reload() {
      var thiz = this
      setTimeout(function () {
        thiz.content.list.forEach((i) => {
          if (i.id) {
            i.posterURL = RD.video().id(i.postId).poster_URL()
          }
          i.posterURL = RD.video().id(i.postId).poster_URL()
          i.videoURL = RD.video().id(i.postId).svideo_URL()
          i.mute = true
        })
        thiz.webItem = JSON.parse(JSON.stringify(thiz.content))
      }, 2000)
    },
    // 分类的标题的点击
    onOpenFixtop(fixtopId) {
      this.$router.push({
        path: '/fixTopic.html',
        query: { id: fixtopId },
      })
    },
    // 进入播放
    onVideoEnter(ref) {
      this.$refs[ref][0].play()
    },
    // 离开停止
    onVideoLeave(ref) {
      this.$refs[ref][0].pause()
    },
    onLookPost(postId) {
      this.$router.push({
        path: '/picDetail.html',
        query: { postId: postId },
      })
    },
    // 鼠标move
    swipeLeft() {
      console.log('swipe left')
      if (this.swipeMoving) {
        return
      }
      this.swipeMoving = true
      this.swipeIndex += 1
      setTimeout(() => {
        this.swipeMoving = false
      }, 500)
    },
    swipeRight() {
      console.log('swipe right')
      if (this.swipeMoving) {
        return
      }
      this.swipeMoving = true
      this.swipeIndex -= 1
      setTimeout(() => {
        this.swipeMoving = false
      }, 500)
    },
    /**
     * swipe filter utils, return if the target index is show or not
     * @Param targetIndex item index to test
     * @Param length array length
     * @Param swipeIndex swipePosition to test
     * @Param forwardGap how many item in the array larger than swipeIndex will be marked as valid
     * @Param backwardGap how many item in the array smaller the swipeIndex will be marked as valid
     */
    swipeFilter(t, l, s, f, b) {
      return !((((t - s) % l) + l) % l > f && (((s - t) % l) + l) % l > b)
    },
    /**
     * return the position index
     * position when swipeIndex == targetIndex return 0
     * forward return  1 2 3
     * backword return total -1 total -2 total -3
     * @Param targetIndex
     * @Param swipeIndex
     * @Param total length of array
     * @Param length of items show
     */ swipePosition(t, s, l, g) {
      return Math.abs((t - (((s % l) + l) % l) + l) % l) <= Math.abs(((((s % l) + l) % l) - t + l) % l)
        ? ((((t - s) % l) + l) % l) % g
        : t > ((s % l) + l) % l
        ? (((-(((s % l) + l) % l) - l + t) % g) + g) % g
        : (((-(((s % l) + l) % l) + t) % g) + g) % g
    },
  },
}
</script>

<style lang="less" scoped>
@media all and (max-width: 800px) {
  .ftv-con {
    width: 100%;
    margin: 0 auto;
    position: relative;
    background-color: #f7f7f7;
    .item-title-container {
      position: relative;
      height: 60px;
      width: 750px;
      margin: 1.7rem auto;
      line-height: 60px;
      text-align: left;
      display: flex;
      .item-red {
        width: 6px;
        height: 6px;
        position: absolute;
        top: 25px;
        left: 10px;
        background-color: #cf0000;
      }
      .item-title {
        font-size: 40px;
        cursor: pointer;
        display: inline-block;
        height: 60px;
        margin-left: 20px;
        padding: 0px 1.5rem;
        font-weight: bold;
        line-height: 60px;
      }
      .item-icon {
        font-size: 22px;
        font-weight: bold;
        line-height: 60px;
      }
    }
    .post-con:hover {
      .post-img {
        transform: scale(1.05);
      }

      .post-text {
        background-color: rgba(0, 0, 0, 0.4);
        width: 92%;
      }
    }

    .post-con {
      video {
        width: 100%;
        height: 100%;
        object-fit: contain;
        background-color: black;
        position: relative;
        cursor: pointer;
      }

      .mute {
        display: block;
        position: absolute;
        right: 2rem;
        top: 2rem;
        font-size: 2rem;
        height: 3rem;
        width: 3rem;
        border: 2px solid white;
        border-radius: 2rem;
        line-height: 3rem;
        color: white;
      }

      .mute.active {
        color: red;
      }

      .rd-img {
        width: 100%;
        height: 100%;
        background: no-repeat 50% / cover;
        cursor: pointer;
        position: absolute;
        top: 0px;
        left: 0px;
      }

      .video-text {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 4.2rem;
        line-height: 4.2rem;
        color: #fff;
        font-size: 1.5rem;
        background-color: rgba(0, 0, 0, 0.3);
      }
    }

    .ftv-model-m_13 {
      height: 51rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;

      .post-con {
        position: absolute;
        overflow: hidden;

        video {
          height: 100%;
          width: 100%;
          background-color: black;
          object-fit: contain;
        }
      }

      .post-con:nth-child(1) {
        width: 85rem;
        height: 51rem;
        top: 0;
        left: 0;
      }

      .post-con:nth-child(2) {
        width: 34rem;
        height: 16.2rem;
        top: 0;
        right: 0;
      }

      .post-con:nth-child(3) {
        width: 34rem;
        height: 16.2rem;
        bottom: 17.3rem;
        right: 0;
      }

      .post-con:nth-child(4) {
        width: 34rem;
        height: 16.2rem;
        bottom: 0;
        right: 0;
      }

      .post-con:nth-child(1n + 5) {
        display: none;
      }
    }

    .ftv-model-m_1111 {
      height: 19.5rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;

      display: flex;
      justify-content: space-between;

      .post-con {
        width: 29.5rem;
        height: 20rem;
        position: relative;
        overflow: hidden;

        video {
          height: 100%;
          width: 100%;
          background-color: black;
          object-fit: contain;
        }
      }

      .post-con:nth-child(1n + 5) {
        display: none;
      }
    }

    .ft-model-4s {
      height: 20rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .post-con {
        width: 29.5rem;
        height: 20rem;
        position: relative;
        overflow: hidden;
      }

      .post-con:nth-child(1n + 5) {
        display: none;
      }
    }

    .ft-model-3s {
      height: 79rem;
      position: relative;

      .pic {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        opacity: 0;
        background: no-repeat 50% / cover;
        transition: all 500ms ease-in-out;
        cursor: pointer;
        z-index: 100;
      }

      .pic.active {
        opacity: 1;
        z-index: 200;
      }

      .text {
        display: flex;
        margin: 1.25rem auto;
        position: absolute;
        bottom: 0px;
        width: 100%;
        justify-content: center;
        z-index: 300;

        .nav-pic {
          height: 1.25rem;
          width: 1.25rem;
          border-radius: 0.66rem;
          border: 1px solid rgba(255, 255, 255, 0.4);
          margin-right: 0.85rem;
          background: rgba(0, 0, 0, 0.5);
          transition: all 500ms ease-in-out;
          cursor: pointer;
        }

        .nav-pic.active {
          background-color: rgb(23, 47, 184);
          width: 3.75rem;
        }
      }
    }

    .ft-model-21 {
      height: 51rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;

      .post-con {
        position: absolute;
        overflow: hidden;
      }

      .post-con:nth-child(1) {
        width: 34rem;
        height: 25rem;
        top: 0;
        left: 0;
      }

      .post-con:nth-child(2) {
        width: 34rem;
        height: 25rem;
        bottom: 0;
        left: 0;
      }

      .post-con:nth-child(3) {
        width: 85rem;
        height: 51rem;
        top: 0;
        right: 0;
      }

      .post-con:nth-child(1n + 4) {
        display: none;
      }
    }

    .ft-model-333 {
      height: 42rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 2rem;

      .post-con {
        min-width: 29.5rem;
        flex: 1;
        height: 20rem;
        position: relative;
        overflow: hidden;
      }

      .post-con:nth-child(1n + 7) {
        display: none;
      }
    }

    .ft-model-14 {
      height: 41rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;

      .post-con {
        position: absolute;
        overflow: hidden;
      }

      .post-con:nth-child(1) {
        width: 62rem;
        height: 41rem;
        top: 0;
        left: 0;
      }

      .post-con:nth-child(2),
      .post-con:nth-child(3),
      .post-con:nth-child(4),
      .post-con:nth-child(5) {
        width: 28rem;
        height: 20rem;
      }

      .post-con:nth-child(2) {
        top: 0;
        right: 29rem;
      }

      .post-con:nth-child(3) {
        bottom: 0;
        right: 29rem;
      }

      .post-con:nth-child(4) {
        top: 0;
        right: 0;
      }

      .post-con:nth-child(5) {
        bottom: 0;
        right: 0;
      }

      .post-con:nth-child(1n + 6) {
        display: none;
      }
    }

    .ft-model-1111 {
      height: 40rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      gap: 2rem;

      .post-con {
        flex: 1;
        height: 40rem;
        position: relative;
        overflow: hidden;
      }

      .post-con:nth-child(1n + 5) {
        display: none;
      }
    }

    .ftv-model-m_swiper {
      width: 730px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      position: relative;
      .swiper-list {
        width: 100%;
        overflow: hidden;
        .video-item {
          position: relative;
          height: 500px;
          width: 100%;
          margin-bottom: 20px;
          flex-shrink: 0;
          background: no-repeat 50% / cover;
          box-sizing: border-box;
          transition: 500ms left, width, top, height ease-in-out;
          cursor: pointer;
          background-color: #fff;
          video {
            width: 100%;
            height: 84%;
            object-fit: contain;
            background-color: black;
            position: relative;
            cursor: pointer;
          }

          .mute {
            display: block;
            position: absolute;
            right: 2rem;
            top: 2rem;
            font-size: 2rem;
            height: 3rem;
            width: 3rem;
            border: 2px solid white;
            border-radius: 2rem;
            line-height: 3rem;
            color: white;
          }

          .mute.active {
            color: red;
          }

          .rd-img {
            width: 100%;
            height: 100%;
            background: no-repeat 50% / cover;
            cursor: pointer;
            position: absolute;
            top: 0px;
            left: 0px;
          }

          .video-play {
            position: absolute;
            right: 20px;
            bottom: 20%;
            width: 50px;
            height: 50px;
            background: no-repeat url(../../assets/play.png);
            background-size: cover;
          }

          .video-text {
            width: 98%;
            font-size: 22px;
            text-align: right;
            .title {
              font-weight: bold;
              height: 50px;
              line-height: 50px;
            }
            .author {
              font-size: 18px;
            }
          }
        }
        .video-item:nth-child(1n + 6) {
          display: none;
        }

        .pic:hover {
          border: 3px solid rgba(215, 20, 12, 0.75);
          .text {
            opacity: 1;
          }
        }
      }

      .swiper-left {
        position: absolute;
        left: -7rem;
        top: 40%;
        cursor: pointer;
        .left {
          width: 6.4rem;
          height: 6.4rem;
          background: rgba(0, 0, 0, 0.25);
          position: relative;
          .left-icon {
            height: 2.5rem;
            width: 2.5rem;
            border-top: 0.3rem solid #dcdcdd;
            border-left: 0.3rem solid #dcdcdd;
            transform: rotate(-45deg);
            position: absolute;
            top: 2rem;
            left: 2.5rem;
          }
        }
      }
      .swiper-right {
        position: absolute;
        right: -7rem;
        top: 40%;
        cursor: pointer;
        .right {
          width: 6.4rem;
          height: 6.4rem;
          background: rgba(0, 0, 0, 0.25);
          position: relative;
          .right-icon {
            height: 2.5rem;
            width: 2.5rem;
            border-bottom: 0.3rem solid #dcdcdd;
            border-right: 0.3rem solid #dcdcdd;
            transform: rotate(-45deg);
            position: absolute;
            top: 2rem;
            right: 2.5rem;
          }
        }
      }
    }
  }
}
@media all and (min-width: 801px) {
  .ftv-con {
    width: 100%;
    margin: 1.7rem auto;
    position: relative;

    .post-con:hover {
      .post-img {
        transform: scale(1.05);
      }

      .post-text {
        background-color: rgba(0, 0, 0, 0.4);
        width: 92%;
      }
    }

    .post-con {
      video {
        width: 100%;
        height: 100%;
        object-fit: contain;
        background-color: black;
        position: relative;
        cursor: pointer;
      }

      .mute {
        display: block;
        position: absolute;
        right: 2rem;
        top: 2rem;
        font-size: 2rem;
        height: 3rem;
        width: 3rem;
        border: 2px solid white;
        border-radius: 2rem;
        line-height: 3rem;
        color: white;
      }

      .mute.active {
        color: red;
      }

      .rd-img {
        width: 100%;
        height: 100%;
        background: no-repeat 50% / cover;
        cursor: pointer;
        position: absolute;
        top: 0px;
        left: 0px;
      }

      .video-text {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 4.2rem;
        line-height: 4.2rem;
        color: #fff;
        font-size: 1.5rem;
        background-color: rgba(0, 0, 0, 0.3);
      }
    }

    .ftv-model-m_13 {
      height: 51rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;

      .post-con {
        position: absolute;
        overflow: hidden;

        video {
          height: 100%;
          width: 100%;
          background-color: black;
          object-fit: contain;
        }
      }

      .post-con:nth-child(1) {
        width: 85rem;
        height: 51rem;
        top: 0;
        left: 0;
      }

      .post-con:nth-child(2) {
        width: 34rem;
        height: 16.2rem;
        top: 0;
        right: 0;
      }

      .post-con:nth-child(3) {
        width: 34rem;
        height: 16.2rem;
        bottom: 17.3rem;
        right: 0;
      }

      .post-con:nth-child(4) {
        width: 34rem;
        height: 16.2rem;
        bottom: 0;
        right: 0;
      }

      .post-con:nth-child(1n + 5) {
        display: none;
      }
    }

    .ftv-model-m_1111 {
      height: 19.5rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;

      display: flex;
      justify-content: space-between;

      .post-con {
        width: 29.5rem;
        height: 20rem;
        position: relative;
        overflow: hidden;

        video {
          height: 100%;
          width: 100%;
          background-color: black;
          object-fit: contain;
        }
      }

      .post-con:nth-child(1n + 5) {
        display: none;
      }
    }

    .ft-model-4s {
      height: 20rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .post-con {
        width: 29.5rem;
        height: 20rem;
        position: relative;
        overflow: hidden;
      }

      .post-con:nth-child(1n + 5) {
        display: none;
      }
    }

    .ft-model-3s {
      height: 79rem;
      position: relative;

      .pic {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        opacity: 0;
        background: no-repeat 50% / cover;
        transition: all 500ms ease-in-out;
        cursor: pointer;
        z-index: 100;
      }

      .pic.active {
        opacity: 1;
        z-index: 200;
      }

      .text {
        display: flex;
        margin: 1.25rem auto;
        position: absolute;
        bottom: 0px;
        width: 100%;
        justify-content: center;
        z-index: 300;

        .nav-pic {
          height: 1.25rem;
          width: 1.25rem;
          border-radius: 0.66rem;
          border: 1px solid rgba(255, 255, 255, 0.4);
          margin-right: 0.85rem;
          background: rgba(0, 0, 0, 0.5);
          transition: all 500ms ease-in-out;
          cursor: pointer;
        }

        .nav-pic.active {
          background-color: rgb(23, 47, 184);
          width: 3.75rem;
        }
      }
    }

    .ft-model-21 {
      height: 51rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;

      .post-con {
        position: absolute;
        overflow: hidden;
      }

      .post-con:nth-child(1) {
        width: 34rem;
        height: 25rem;
        top: 0;
        left: 0;
      }

      .post-con:nth-child(2) {
        width: 34rem;
        height: 25rem;
        bottom: 0;
        left: 0;
      }

      .post-con:nth-child(3) {
        width: 85rem;
        height: 51rem;
        top: 0;
        right: 0;
      }

      .post-con:nth-child(1n + 4) {
        display: none;
      }
    }

    .ft-model-333 {
      height: 42rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 2rem;

      .post-con {
        min-width: 29.5rem;
        flex: 1;
        height: 20rem;
        position: relative;
        overflow: hidden;
      }

      .post-con:nth-child(1n + 7) {
        display: none;
      }
    }

    .ft-model-14 {
      height: 41rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;

      .post-con {
        position: absolute;
        overflow: hidden;
      }

      .post-con:nth-child(1) {
        width: 62rem;
        height: 41rem;
        top: 0;
        left: 0;
      }

      .post-con:nth-child(2),
      .post-con:nth-child(3),
      .post-con:nth-child(4),
      .post-con:nth-child(5) {
        width: 28rem;
        height: 20rem;
      }

      .post-con:nth-child(2) {
        top: 0;
        right: 29rem;
      }

      .post-con:nth-child(3) {
        bottom: 0;
        right: 29rem;
      }

      .post-con:nth-child(4) {
        top: 0;
        right: 0;
      }

      .post-con:nth-child(5) {
        bottom: 0;
        right: 0;
      }

      .post-con:nth-child(1n + 6) {
        display: none;
      }
    }

    .ft-model-1111 {
      height: 40rem;
      position: relative;
      overflow: hidden;
      width: 120rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      gap: 2rem;

      .post-con {
        flex: 1;
        height: 40rem;
        position: relative;
        overflow: hidden;
      }

      .post-con:nth-child(1n + 5) {
        display: none;
      }
    }
  }
}
</style>

